export const RoleTypes = [
  { value: "SALES", label: "Sales Officer" },
  { value: "BRANCH", label: "Branch Admin" },
  { value: "MANAGEMENT", label: "Management" },
  { value: "ADMIN", label: "Admin" },
];
